import React from 'react';
import Panel from '../../../shared/components/Panel';
import ToDo from './ToDo';
import { connect } from 'react-redux';
import {withTranslation} from "react-i18next";

const ImproveYourProfile = (props) => (
  <Panel
    md={12}
    lg={6}
    xl={4}
    xs={12}
    title={props.t('overview.improve_profile.title')}
    subhead={props.t('overview.improve_profile.subtitle')}
    onRefresh={()=>{}}
  >
    <ToDo id="1" label={props.t('overview.improve_profile.register_at_engrave')} checked={true} />
    <ToDo id="2" label={props.t('overview.improve_profile.create_blog')} checked={!!(props.blogs.blog)} />
    <ToDo id="3" label={props.t('overview.improve_profile.add_your_blog_to_profile')} checked={ !! props.steemAccount.website}  />
    <ToDo id="4" label={props.t('overview.improve_profile.write_something_about_you')}  checked={ !! props.steemAccount.about}/>
    {/* <ToDo id="5" label="Fill in social profiles" />
    <ToDo id="6" label="Make a sandwich" /> */}
  </Panel>
);

const mapStateToProps = (state) => {
  return {
    steemAccount: state.steemAccount,
    blogs: state.blogs
  }
}

export default connect(mapStateToProps)(withTranslation('dashboard')(ImproveYourProfile));
